export default __webpack_public_path__ + "locales/pt/InfoPanel.json?hash=348eefb8d210dafc633c9713901148a8";